export const GET_SETTING_NOTICE_REQUEST_ASYNC =
  'GET_SETTING_NOTICE_REQUEST_ASYNC';
export const GET_SETTING_NOTICE_REQUEST_SUCCESS =
  'GET_SETTING_NOTICE_REQUEST_SUCCESS';

export const UPDATE_SETTING_NOTICE_REQUEST_ASYNC =
  'UPDATE_SETTING_NOTICE_REQUEST_ASYNC';

export const UPDATE_SETTING_BUILDER_CONFIG_ASYNC =
  'UPDATE_SETTING_BUILDER_CONFIG_ASYNC';
export const UPDATE_SETTING_NOTICE_REQUEST_SUCCESS =
  'UPDATE_SETTING_NOTICE_REQUEST_SUCCESS';

export const GET_SETTING_PROJECT_OPERATION_ASYNC =
  'GET_SETTING_PROJECT_OPERATION_ASYNC';
export const GET_SETTING_BUILDER_CONFIG_ASYNC =
  'GET_SETTING_BUILDER_CONFIG_ASYNC';
export const GET_SETTING_PROJECT_OPERATION_SUCCESS =
  'GET_SETTING_PROJECT_OPERATION_SUCCESS';
export const GET_SETTING_BUILDER_CONFIGS_SUCCESS =
  'GET_SETTING_BUILDER_CONFIGS_SUCCESS';

export const UPDATE_SETTING_PROJECT_OPERATION_ASYNC =
  'UPDATE_SETTING_PROJECT_OPERATION_ASYNC';
export const UPDATE_SETTING_PROJECT_OPERATION_SUCCESS =
  'UPDATE_SETTING_PROJECT_OPERATION_SUCCESS';

export const SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_ASYNC =
  'SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_ASYNC';
export const SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_SUCCESS =
  'SETTING_ASSIGNEE_NOTICE_BUILDER_LEVEL_SUCCESS';

export const GET_ASSIGNEE_NOTICE_BUILDER_LEVEL_ASYNC =
  'GET_ASSIGNEE_NOTICE_BUILDER_LEVEL_ASYNC';
export const GET_ASSIGNEE_NOTICE_BUILDER_LEVEL_SUCCESS =
  'GET_ASSIGNEE_NOTICE_BUILDER_LEVEL_SUCCESS';

export const GET_CUSTOM_TERMS = 'GET_CUSTOM_TERMS';
export const GET_CUSTOM_TERMS_SUCCESS = 'GET_CUSTOM_TERMS_SUCCESS';

export const UPDATE_CUSTOM_TERMS = 'UPDATE_CUSTOM_TERMS';

export const UPDATE_CUSTOM_COLOR_PALETTES_ASYNC =
  'UPDATE_CUSTOM_COLOR_PALETTES_ASYNC';
export const UPDATE_HO_CUSTOM_COLOR_PALETTES_ASYNC =
  'UPDATE_HO_CUSTOM_COLOR_PALETTES_ASYNC';
export const UPDATE_CUSTOM_COLOR_PALETTES_SUCCESS =
  'UPDATE_CUSTOM_COLOR_PALETTES_SUCCESS';
export const UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS =
  'UPDATE_HO_CUSTOM_COLOR_PALETTES_SUCCESS';
export const SET_CURRENT_CUSTOM_COLOR = 'SET_CURRENT_CUSTOM_COLOR';
export const SET_HO_CURRENT_CUSTOM_COLOR = 'SET_HO_CURRENT_CUSTOM_COLOR';
export const CANCEL_TEMPORARY_COLOR_PICKER = 'CANCEL_TEMPORARY_COLOR_PICKER';
export const CANCEL_HO_TEMPORARY_COLOR_PICKER = 'CANCEL_HO_TEMPORARY_COLOR_PICKER';
export const GET_SETTING_BUILDER_CONFIGS_SUCCESS_LOADER =
  'GET_SETTING_BUILDER_CONFIGS_SUCCESS_LOADER';

export const GET_TENANT_PROFILE_ASYNC = 'GET_TENANT_PROFILE_ASYNC';
export const GET_TENANT_PROFILE_SUCCESS = 'GET_TENANT_PROFILE_SUCCESS';


// WEBPACK FOOTER //
// ./src/Setting/constants.js